import moment from "moment"
import Link from "next/link"
import { createObjectPagePathname, getMediaUrl } from "@/services/pathname"
import 'moment/locale/fr'
import { getName } from "@/services/aroeven"
moment.locale('fr')

type CardProps = {
    schoolTrip: SchoolTrip
}

export default function Card({
    schoolTrip
}: CardProps) {


    return (
        <Link className="vignette -type-1 h-100" href={createObjectPagePathname('SchoolTrip', schoolTrip)}>
            <div className="vignette__image">
                <div className={"bandeau"}>
                    <i className="fi fi-rr-ruler-triangle" /> Sortie scolaire
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <h4 className="vignette__title py-10">
                            {schoolTrip.name}
                        </h4>
                    </div>
                    <div>
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className="lh-1 mb-5">Proposé par {getName(schoolTrip.proposedBy)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}